import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { getCandidateProfileId } from '@/Profile/selectors/profile'

import WorkplacePolicy from '../../containers/WorkplacePolicy'
import WorkplacePolicyForm from '../../components/WorkplacePolicyForm'
import MobileContainer from '../../components/MobileContainer'
import WorkPlacePolicyPreview from '../../components/WorkplacePolicyPreview'
import WorkplacePolicyEmptyState from '../../components/WorkplacePolicyEmptyState'

const MobileWorkplacePolicyScene = ({ match }) => {
  const candidateId = useSelector(getCandidateProfileId)

  return (
    <WorkplacePolicy candidateId={candidateId}>
      {({
        editing,
        toggleEditing,
        isSaving,
        submitWorkplacePolicy,
        defaultValues,
        availableCountries,
        enabledForCurrentState,
        workplacePolicies,
        workplacePolicySubmitError,
        locationOsmStrings,
      }) => (
        <MobileContainer
          enabledForCurrentState={enabledForCurrentState}
          candidateSlug={match.params.candidateSlug}
          shortTitle="Location and remote preferences"
          editing={editing}
          toggleEditing={toggleEditing}
          editButtonAriaLabel="Edit location and remote preferences">
          <Choose>
            <When condition={editing}>
              <WorkplacePolicyForm
                countries={availableCountries}
                defaultValues={defaultValues}
                toggleEditing={() => toggleEditing(!editing)}
                submitWorkplacePolicy={submitWorkplacePolicy}
                isSaving={isSaving}
                workplacePolicySubmitError={workplacePolicySubmitError}
                locationOsmStrings={locationOsmStrings}
              />
            </When>
            <When condition={!!workplacePolicies.length}>
              <WorkPlacePolicyPreview remotePolicies={workplacePolicies} />
            </When>
            <Otherwise>
              <WorkplacePolicyEmptyState toggleEditing={toggleEditing} />
            </Otherwise>
          </Choose>
        </MobileContainer>
      )}
    </WorkplacePolicy>
  )
}

MobileWorkplacePolicyScene.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      candidateSlug: PropTypes.string,
    }),
  }),
}

export default MobileWorkplacePolicyScene
